import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataPagesMedicalRecords } from "reduxx/actions/pages/user/medicalRecords";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { handleChangeProfileData } from 'reduxx/actions/pages/user/login';
import { useEffect } from 'react';
import { EDIT_MEDICAL_RECORDS_4 } from 'apis';
import apiRequest from 'utils/apiRequest';

const EditMedicalRecord4 = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { insurances } = useSelector(state => state.initialData);
    const { nationalCode, insuranceId, insuranceTitle } = useSelector(state => state.medicalRecords);

    useEffect(() => {
        dispatch(handleChangeDataPagesMedicalRecords('nationalCode', profile.nationalCode));
        dispatch(handleChangeDataPagesMedicalRecords('insuranceId', profile.medicalRecords.insuranceId));
        dispatch(handleChangeDataPagesMedicalRecords('insuranceTitle', profile.medicalRecords.insuranceTitle));
    }, [EditMedicalRecord4]);


    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        
        if(name === 'insuranceTitle') {
            dispatch(handleChangeDataPagesMedicalRecords(name, value));

        	let selectedInsurance = insurances.find(item => item.title === value);
        	dispatch(handleChangeDataPagesMedicalRecords('insuranceId', selectedInsurance.id));
        }
        else if(name === 'nationalCode') {
            dispatch(handleChangeDataPagesMedicalRecords(name, changeNumberPersianAndArabic(value)));
        }
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };


    const handleSubmitForm = () => {
    	if(!insuranceId)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'نوع بیمه را مشخص کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
    	else if(nationalCode === null || nationalCode.trim().length === 0)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'کد ملی را وارد کنید!', severity: 'error', vertical: 'top', horizontal: 'right'}));
    	else if(nationalCode.trim().length !== 10)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'کدملی باید 10 رقم باشد', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else {
			apiRequest({
                dispatch,
                endpoint: EDIT_MEDICAL_RECORDS_4,
                method: 'post',
                data: { nationalCode, insuranceId },
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                	let newProfile = profile;
                	newProfile.medicalRecords.nationalCode = nationalCode;
                	newProfile.medicalRecords.insuranceId = insuranceId;
                	newProfile.medicalRecords.insuranceTitle = insuranceTitle;
                	dispatch(handleChangeProfileData(newProfile));

                    navigate(`/medical-record/verify`);
                }
            });
		}
    };		


    const LENGTH_THRESHOLD = 20;
    const isLongSelected = insuranceTitle && insuranceTitle.length > LENGTH_THRESHOLD;

    return (
        
        <div className={sharedStyles.container}>
        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={[formStyles.title, formStyles['mb-24'], formStyles['text-right']].join(' ')}>نوع بیمه و کدملی خود را وارد فرمایید</div>

				<select name="insuranceTitle" value={insuranceTitle} onChange={handelChangeInputs}  className={[formStyles.input, isLongSelected ? formStyles['small-font'] : ''].join(' ')}>
					<option>نوع بیمه</option>
					{
						insurances.map((insurance, key) => (
							<option key={key} className={insurance.title.length > 20 ? formStyles['small-font'] : ''} >{insurance.title}</option>
						))
					}
	                    
                </select>

				<input name="nationalCode" value={nationalCode} onChange={handelChangeInputs} className={formStyles.input} placeholder="کد ملی" />
				
				<button onClick={handleSubmitForm} className={formStyles.button}>تایید و ثبت نهایی</button>
        	</div>

		</div>

    );
}

export default EditMedicalRecord4;